module.exports = __webpack_public_path__ + "img/1ed_list.b2ca3c94.svg";